import { AlertTriangle } from "lucide-react";

/**
 * Inline error pill — never prints raw JSON. Pass a parsed string only.
 */
export default function ErrorMessage({ message, testid, tone = "danger" }) {
  if (!message) return null;
  const palette = tone === "danger"
    ? { fg: "#A2362B", bg: "rgba(162, 54, 43, 0.08)", border: "rgba(162, 54, 43, 0.25)" }
    : { fg: "#7A5A12", bg: "rgba(201, 162, 74, 0.10)", border: "rgba(201, 162, 74, 0.30)" };

  return (
    <div
      role="alert"
      data-testid={testid}
      className="flex items-start gap-2 text-sm"
      style={{
        background: palette.bg,
        border: `1px solid ${palette.border}`,
        color: palette.fg,
        padding: "10px 12px",
        borderRadius: 2,
        lineHeight: 1.45,
      }}
    >
      <AlertTriangle size={16} style={{ marginTop: 2, flexShrink: 0 }} />
      <span>{message}</span>
    </div>
  );
}
